import { baseEnvironment } from './base.environment';

export const environment = {
  ...baseEnvironment,
  title: 'CR LINC - Qual',
  oktaAuthIssuerURL: 'https://tcenergyhub.oktapreview.com/oauth2/default',
  oktaClientId: '0oa5w6yrjyH8MYmym1d7',
  graphQLUrl: 'https://api-flask.crlinc-qual.tcenergy.com/graphql',
  fieldVisionUrl: 'https://fv.crlinc-qual.tcenergy.com/',
  publicFunctionApiKey: 'da2-yqq4jvcl45gqnl23v575y44ena',
};
